module.exports = __webpack_public_path__ + "static/media/heart4.1d988c8b.png";